export default [
    {
        name: 'bikeModel',
        type: 'gltfModel',
        path: 'models/bike/bike2.glb'
    }
]